export default __webpack_public_path__ + "static/media/celebrate.03eb9c1a3fe3d251fd869a779a68498c.svg";